export const COMMON_STATE = {
    ARCHIVED: 'ARCHIVED'
}
